    import axios from "axios";
    import { ApiConfig } from "../constants/apiConfig";

    export const fetchRiwayatJurnal = async (siswaId, page = 1, search = "") => {
    try {
        const response = await axios.get(`${ApiConfig.baseUrl}/absensi`, {
        params: {
            siswa_id: siswaId,
            page: page,
            search: search,
        },
        headers: {
            Authorization: `Bearer ${localStorage.getItem("student_token") || ""}`,
            Accept: "application/json",
        },
        });

        if (response.status === 200 && response.data.success) {
        return {
            success: true,
            data: response.data.data,
        };
        } else {
        return {
            success: false,
            message: response.data.message || "Gagal mengambil data",
        };
        }
    } catch (error) {
        return {
        success: false,
        message: error.message || "Terjadi kesalahan saat mengambil data",
        };
    }
    };
